<template>
    <v-app>
        <v-navigation-drawer
            v-model="nav"
            app
            clipped
            mobile-breakpoint="860"
            :width="$vuetify.breakpoint.width < 860 ? '100%' : 280"
            :style="`top: ${$vuetify.breakpoint.width < 860 ? 56 : 64}px`"
            hide-overlay
        >
            <div
                @mouseleave="
                    () => {
                        if ($vuetify.breakpoint.width >= 860)
                            previewScene = null;
                    }
                "
                :style="
                    $vuetify.breakpoint.width < 860 &&
                    $vuetify.breakpoint.height > 500
                        ? 'overflow: auto;position: absolute;bottom: 0;left: 0;right: 0;scroll-snap-type: y mandatory;top: calc(30vh + 15px);height: calc(70vh - 76px);'
                        : ''
                "
                @scroll="scroll"
            >
                <v-list dense>
                    <v-subheader
                        class="primary--text font-weight-medium ml-2"
                        style="font-size: 16px"
                        >WARTE UWAGI</v-subheader
                    >
                    <v-list-item-group
                        color="primary"
                        v-model="listPopularIndex"
                    >
                        <v-list-item
                            v-for="(item, index) in APP_DATA.scenes.filter(
                                (n) => n.popular
                            )"
                            :key="index"
                            ref="sceneLink1"
                            class="sceneListEntry"
                            @click="
                                () => {
                                    activeScene = item.id;
                                    if ($vuetify.breakpoint.width < 860)
                                        nav = false;
                                }
                            "
                            :dense="$vuetify.breakpoint.width < 860"
                            :sceneid="item.id"
                            :class="
                                activeScene == item.id
                                    ? 'v-list-item--active'
                                    : ''
                            "
                            @mouseover="
                                (event) => {
                                    previewScene = item.id;
                                    $refs.qv.$el.style.top =
                                        $refs.sceneLink1[
                                            index
                                        ].$el.getBoundingClientRect().top -
                                        134 +
                                        'px';
                                }
                            "
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    item.name
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{
                                    item.details
                                }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>

                    <v-subheader
                        class="primary--text font-weight-medium ml-2"
                        style="font-size: 16px"
                        >WSZYSTKIE</v-subheader
                    >
                    <v-list-item-group
                        color="primary"
                        v-model="activeSceneIndex"
                    >
                        <v-list-item
                            v-for="(item, index) in APP_DATA.scenes"
                            :key="index"
                            ref="sceneLink"
                            :dense="$vuetify.breakpoint.width < 860"
                            class="sceneListEntry"
                            :sceneid="item.id"
                            @click="
                                () => {
                                    activeScene = item.id;
                                    if ($vuetify.breakpoint.width < 860)
                                        nav = false;
                                }
                            "
                            :class="
                                activeScene == item.id
                                    ? 'v-list-item--active'
                                    : ''
                            "
                            @mouseover="
                                (event) => {
                                    previewScene = item.id;
                                    $refs.qv.$el.style.top =
                                        $refs.sceneLink[
                                            index
                                        ].$el.getBoundingClientRect().top -
                                        134 +
                                        'px';
                                }
                            "
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    item.name
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{
                                    item.details
                                }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>

                    <v-list-item class="mt-7 mb-14 text-center">
                        <v-list-item-content>
                            <v-list-item-title
                                >Copyright &copy; Kacper
                                Golik</v-list-item-title
                            >
                            <v-list-item-subtitle
                                ><a href="3rd-party-licenses.txt"
                                    >Licencje open-source</a
                                ></v-list-item-subtitle
                            >
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-navigation-drawer>

        <v-app-bar clipped-left app color="primary" dark>
            <v-app-bar-nav-icon
                @click="nav = !nav"
                v-if="$vuetify.breakpoint.width < 860"
            ></v-app-bar-nav-icon>
            <img
                src="@/assets/logo.png"
                height="100%"
                v-if="$vuetify.breakpoint.width >= 860"
            />
            <v-toolbar-title
                style="padding-bottom: 0"
                v-if="$vuetify.breakpoint.width >= 860"
            >
                <div style="margin-left: 10px">
                    Zespół Szkół Elektronicznych
                    <div style="font-size: 0.7em">
                        im. Wojska Polskiego w Bydgoszczy
                    </div>
                </div>
            </v-toolbar-title>
            <v-toolbar-title
                class="text-center"
                :style="`padding-bottom: 0; flex: 1;padding-right:${
                    $vuetify.breakpoint.width >= 860 ? 0 : 55
                }px`"
            >
                <div
                    style="overflow: hidden; text-overflow: ellipsis"
                    :style="{
                        'padding-right':
                            $vuetify.breakpoint.width >= 860 ? '40px' : 0,
                    }"
                >
                    {{
                        APP_DATA.scenes.filter((n) => n.id == activeScene)[0]
                            .name
                    }}
                    <div style="font-size: 0.7em">
                        {{
                            APP_DATA.scenes.filter(
                                (n) => n.id == activeScene
                            )[0].details
                        }}
                    </div>
                </div>
            </v-toolbar-title>
        </v-app-bar>

        <v-main>
            <engine :scene="activeScene" />

            <v-btn
                elevation="6"
                small
                style="
                    position: absolute;
                    width: 300px;
                    top: -2px;
                    left: calc(50% - 150px);
                "
                v-show="
                    APP_DATA.scenes.filter((n) => n.id == activeScene)[0]
                        .description
                "
                @click="
                    $refs.info.$el.style.transform = 'translateY(-5px)';
                    infoOpened = true;
                "
                >Pokaż informacje</v-btn
            >
            <v-card
                id="info"
                ref="info"
                :width="$vuetify.breakpoint.width >= 860 ? 550 : 300"
                height="auto"
                class="flex-column body-2"
            >
                <p
                    :style="{ visibility: infoOpened ? 'visible' : 'hidden' }"
                    class="pa-2 flex-grow-1 ma-0"
                    style="height: calc(100% - 28px); overflow: auto"
                    v-html="
                        APP_DATA.scenes.filter((n) => n.id == activeScene)[0]
                            .description
                    "
                ></p>
                <v-btn
                    elevation="6"
                    block
                    small
                    @click="
                        $refs.info.$el.style.transform = 'translateY(-230px)';
                        infoOpened = false;
                    "
                    >Ukryj informacje</v-btn
                >
            </v-card>

            <quick-view
                id="qv"
                ref="qv"
                class="elevation-6"
                v-show="
                    ($vuetify.breakpoint.width >= 860 || nav) && previewScene
                "
                :image="previewScene"
            />
            <loader id="loader" />

            <img
                id="mobileLogo"
                src="@/assets/logo.png"
                height="80"
                v-if="$vuetify.breakpoint.width < 860"
            />
        </v-main>
    </v-app>
</template>

<script>
import Loader from "./components/Loader";
import Engine from "./components/Engine";
import QuickView from "./components/QuickView";

export default {
    name: "App",

    components: {
        Loader,
        Engine,
        QuickView,
    },
    watch: {
        nav: function () {
            let temp = this.previewScene;
            this.previewScene = null;
            let t = this;
            setTimeout(() => {
                t.previewScene = temp;
            }, 1);
        },
        activeScene: function (newVal) {
            if (
                this.APP_DATA.scenes.filter((n) => n.id == newVal)[0] &&
                this.infoOpened
            )
                if (
                    !this.APP_DATA.scenes.filter((n) => n.id == newVal)[0]
                        .description
                )
                    this.$refs.info.$el.style.transform = "translateY(-230px)";
                else this.$refs.info.$el.style.transform = "translateY(0px)";
        },
    },
    data: () => ({
        nav: false,
        infoOpened: true,

        APP_DATA: window.APP_DATA,
        previewScene: null,
        activeScene: window.APP_DATA.scenes[0].id,
        activeSceneIndex: 0,
        listPopularIndex: null,
    }),
    methods: {
        scroll(event) {
            let sel = null;
            this.$refs.sceneLink1.forEach((n) => {
                if (n.$el.offsetTop + 42 < event.target.scrollTop) sel = n.$el;
            });
            this.$refs.sceneLink.forEach((n) => {
                if (n.$el.offsetTop + 422 < event.target.scrollTop) sel = n.$el;
            });

            if (sel) this.previewScene = sel.getAttribute("sceneid");
        },
    },
    mounted() {
        this.nav = this.$vuetify.breakpoint.width >= 860;
        if (this.$vuetify.breakpoint.width < 860) {
            this.previewScene = this.APP_DATA.scenes.filter((n) => n.popular)[0].id;
        }

        let t = this;
        window.addEventListener("message", (e) => {
            if (e.data.event == "LOADED") {
                setTimeout(() => {
                    document.getElementById("Loader").classList.add("hide");
                    setTimeout(() => {
                        document.getElementById("loader").remove();
                    }, 2000);
                }, 1000);
            } else if (e.data.event == "CHANGED" && e.data.data) {
                t.activeScene = e.data.data;
                t.activeSceneIndex = t.APP_DATA.scenes
                    .map((n) => n.id)
                    .indexOf(e.data.data);
                t.listPopularIndex = t.APP_DATA.scenes
                    .filter((n) => n.popular)
                    .map((n) => n.id)
                    .indexOf(e.data.data);
            }
        });
    },
};
</script>
<style scoped>
#info {
    position: absolute;
    top: 0;
    left: calc(50% - 275px);
    overflow: hidden;
    max-height: 230px;
    transition: transform 0.4s ease-in-out;
    display: flex;
}
#qv {
    position: absolute;
    left: -20px;
    border-radius: 4px;
    pointer-events: none;
    font-size: 0;
}
#qv::before {
    content: "";
    display: inherit;
    width: 30px;
    height: 30px;
    transform: rotate(45deg);
    transform-origin: 0 0;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
        0px 6px 10px 0px rgba(0, 0, 0, 0.14),
        0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    z-index: 99;
    position: absolute;
    top: 71px;
    left: 1px;
}
#mobileLogo {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
<style>
html,
body {
    height: 100%;
    width: 100%;
    overflow: hidden !important;
}
.v-list-item__content {
    padding: 5px 0 !important;
}
@media only screen and (max-width: 860px) {
    .v-list-item__content {
        padding: 4px 0 !important;
    }
    #info {
        left: calc(50% - 150px) !important;
    }
    #qv {
        position: fixed;
        left: 0 !important;
        top: 0 !important;
    }
    #qv::before {
        left: 50vw !important;
        top: initial !important;
        bottom: 1px;
    }
    .sceneListEntry {
        scroll-snap-align: start;
    }
}
@media only screen and (max-height: 500px) {
    #qv {
        display: none !important;
    }
}
</style>